document.addEventListener("DOMContentLoaded", function () {
  let bars = document.querySelectorAll('.js-bar-container');

  bars.forEach(item => {
    let customOptions = item.closest('.announcement-bar-section').dataset["customOptions"];

    if (customOptions) {
      customOptions = JSON.parse(customOptions);
    }

    new Swiper(item, {
      spaceBetween: 0,
      slidesPerView: "auto",
      breakpoints: {
        320: {
          initialSlide: 0,
          slidesPerView: 1
        },
        650: {
          initialSlide: 0,
          slidesPerView: 1
        },
        800: {
          initialSlide: 0,
          slidesPerView: 1
        },
        900: {
          initialSlide: 0,
          slidesPerView: "auto"
        }
      },
      ...customOptions
    });
  })


});

document.addEventListener("DOMContentLoaded", function () {
  new Swiper('.js-bar-no-container', {
    spaceBetween: 0,
    breakpoints: {
      320: {
        initialSlide: 0,
        slidesPerView: 1
      },
      650: {
        initialSlide: 0,
        slidesPerView: 1
      },
      800: {
        initialSlide: 0,
        slidesPerView: 1
      },
      900: {
        initialSlide: 0,
        slidesPerView: "auto"
      }
    }
  });
});

